import React from 'react'

interface MultiSelectCheckIconProps {
  size?: number
  className?: string
}

export const MultiSelectCheckIcon: React.FC<MultiSelectCheckIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.33 4L6 11.33L2.67 8"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
